import { useMutation } from '@tanstack/react-query';
import { useActiveBrowser, useExtension, useGetCartQuery, useGetFeedback } from '.';
import { SadFeedbackForm } from 'src/components';
import type { TReviewFormState } from 'src/types';

export const useFeedbackReviewMutation = (
  setReviewFormState: React.Dispatch<React.SetStateAction<TReviewFormState>>,
  cartId: string,
) => {
  const { hideReviewCTA } = useGetFeedback();
  const { extExists } = useExtension();
  const activeBrowser = useActiveBrowser();
  const cartQuery = useGetCartQuery({ cartId });

  return useMutation({
    mutationFn: async ({
      reaction,
      data,
    }: {
      reaction: 'happy' | 'unhappy';
      data?: SadFeedbackForm | undefined;
    }): Promise<boolean> => {
      const body = {
        ...data,
        cartId,
        reaction,
        browser: activeBrowser,
        extPresent: extExists,
        vendor: cartQuery.data?.vendor,
      };

      const res = await fetch(`/api/contact/get-feedback`, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        throw new Error('Error submitting feedback');
      }

      // return true to trigger the onSuccess below
      return true;
    },
    onMutate: () => {
      hideReviewCTA('interacted');
    },
    onSuccess: () => {
      hideReviewCTA('completed');
      setReviewFormState('thanks');
    },
    onError: () => {
      // Roll back the interacted cooldown so the user can retry
      localStorage.removeItem('feedbackReview');
    },
  });
};
